/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-one-expression-per-line */
import styled from 'styled-components';
import Skeleton from '@material-ui/lab/Skeleton';
import boxShadowGenerator from '@utils/boxShadowGenerator';
import { BgColors } from '@styles/index';
import CardCarousel from './CardCarousel';

const SecWrapper = styled.section`
  position: relative;
  margin: auto;
  margin-top: 135px;
  padding-bottom: 32px;
  width: 1376px;
  @media (max-width: 70.95em) {
    width: 728px;
    margin-top: 66px;
  }
  @media (max-width: 47.95em) {
    width: 100%;
  }
`;

const CardContianer = styled.div`
  width: 480px;
  height: 228px;
  margin-right: 24px;
  cursor: pointer;
  @media (max-width: 70.95em) {
    width: 272px;
    height: 275px;
    margin: 0 16px 16px 0;
  }
`;

const CardWrapper = styled.div`
  width: 440px;
  height: inherit;
  padding: 24px;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  border-radius: 8px;
  margin-left: 40px;
  position: relative;
  padding-left: 124px;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  background-color: ${BgColors.WHITE};
  @media (max-width: 70.95em) {
    width: 100%;
    margin: 0;
    padding: 0;
    & > span:last-child {
      margin: 0 0 32px 16px;
    }
  }
`;

const CardThumbnail = styled(Skeleton)`
  width: 140px;
  height: 180px;
  box-shadow: ${({ theme }) => boxShadowGenerator({ theme })};
  border-radius: 8px;
  position: absolute;
  left: -40px;
  background-size: cover;
  object-fit: cover;
  @media (max-width: 70.95em) {
    width: 272px;
    position: relative;
    left: 0;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;
    min-height: 140px;
    height: 140px;
  }
`;

const TopContent = styled.div`
  display: flex;
  flex-direction: column;
  @media (max-width: 70.95em) {
    padding: 16px;
    width: 80%;
  }
`;

const Card = () => {
  return (
    <CardContianer>
      <CardWrapper>
        <CardThumbnail variant="rect" animation={false} />
        <TopContent>
          <Skeleton variant="text" />
          <Skeleton variant="text" />
        </TopContent>
        <Skeleton variant="text" width="60%" />
      </CardWrapper>
    </CardContianer>
  );
};

const Loading = () => {
  return (
    <SecWrapper>
      <CardCarousel
        label={<Skeleton variant="text" width={300} />}
        subLabel={<Skeleton variant="text" width={320} />}
        step={2}
        type="dummy"
      >
        {[1, 2].map((user) => (
          <Card key={user} />
        ))}
      </CardCarousel>
    </SecWrapper>
  );
};

export default Loading;
